import React from 'react';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css'; // Import KaTeX styles
import LatexDecoder from '../../utils/LatexDecoder';

const Question = ({ question, selectedAnswer, onSelectAnswer, feedback }) => {
    const { questionText, answerType } = question.content;

    const choiceDisplay = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

    return (
        <div className="question-container">
            {/* Render Mixed Content in Question Text */}
            <h2 className="question-text font-1">{LatexDecoder(questionText)}</h2>
            <p className="margin-btm-15">
                {answerType === 'multiple-choice-single' || answerType === 'true-false'
                    ? 'Select one answer'
                    : answerType === 'multiple-choice-multiple'
                        ? 'Select multiple answers'
                        : ''}
            </p>
            {/* Multiple Choice (Single and Multiple Correct) */}
            {(answerType === 'multiple-choice-single' || answerType === 'multiple-choice-multiple') && (
                <div className="choices-container">
                    {question.choices.map((choice, index) => (
                        <button
                            key={choice.id}
                            onClick={() =>
                                onSelectAnswer(
                                    answerType === 'multiple-choice-multiple'
                                        ? choice.text
                                        : selectedAnswer === choice.text
                                            ? null
                                            : choice.text
                                )
                            }
                            className={`choice-button font-3 ${feedback
                                ? choice.isCorrect
                                    ? 'choice-correct'
                                    : selectedAnswer?.includes(choice.text)
                                        ? 'choice-incorrect'
                                        : ''
                                : selectedAnswer?.includes(choice.text)
                                    ? 'choice-selected'
                                    : ''
                                }`}
                            disabled={!!feedback}
                        >
                            <span className="choice-id">{choiceDisplay[index]}</span>
                            <span className="choice-text">
                                {LatexDecoder(choice.text)}
                            </span>
                            {feedback && (
                                <span className="choice-icon">
                                    {choice.isCorrect ? (
                                        <AiOutlineCheck className="icon-correct font-1" />
                                    ) : selectedAnswer?.includes(choice.text) ? (
                                        <AiOutlineClose className="icon-incorrect font-1" />
                                    ) : null}
                                </span>
                            )}
                        </button>
                    ))}
                    {feedback && (
                        <p className={`feedback-text font-3 ${feedback.correct ? 'text-correct' : 'text-incorrect'}`}>
                            {feedback.correct
                                ? 'Correct!'
                                : LatexDecoder(feedback.justification)}
                        </p>
                    )}
                </div>
            )}

            {/* True/False */}
            {answerType === 'true-false' && (
                <div className="choices-container">
                    {question.choices.map((choice) => (
                        <button
                            key={choice.id}
                            onClick={() => onSelectAnswer(choice.text)}
                            className={`choice-button font-3 ${feedback
                                ? choice.isCorrect
                                    ? 'choice-correct'
                                    : selectedAnswer === choice.text
                                        ? 'choice-incorrect'
                                        : ''
                                : selectedAnswer === choice.text
                                    ? 'choice-selected'
                                    : ''
                                }`}
                            disabled={!!feedback}
                        >
                            <span className="choice-text">{LatexDecoder(choice.text)}</span>
                            {feedback && (
                                <span className="choice-icon">
                                    {choice.isCorrect ? (
                                        <AiOutlineCheck className="icon-correct font-1" />
                                    ) : selectedAnswer === choice.text ? (
                                        <AiOutlineClose className="icon-incorrect font-1" />
                                    ) : null}
                                </span>
                            )}
                        </button>
                    ))}
                    {feedback && (
                        <p className={`feedback-text font-3 ${feedback.correct ? 'text-correct' : 'text-incorrect'}`}>
                            {feedback.correct
                                ? 'Correct!'
                                : LatexDecoder(feedback.justification)}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default Question;

            {/* Text Input */}
            {/*{(answerType === 'text' || answerType === 'fill-in-the-blank') && (*/}
            {/*    <div className="text-input-container">*/}
            {/*        <input*/}
            {/*            type="text"*/}
            {/*            value={selectedAnswer || ''}*/}
            {/*            onChange={(e) => onSelectAnswer(e.target.value)}*/}
            {/*            className={`text-input ${feedback*/}
            {/*                    ? feedback.correct*/}
            {/*                        ? 'input-correct'*/}
            {/*                        : 'input-incorrect'*/}
            {/*                    : ''*/}
            {/*                }`}*/}
            {/*            placeholder="Type your answer here"*/}
            {/*            disabled={!!feedback}*/}
            {/*        />*/}
            {/*        {feedback && (*/}
            {/*            <p className={`feedback-text ${feedback.correct ? 'text-correct' : 'text-incorrect'}`}>*/}
            {/*                {feedback.correct ? 'Correct!' : `Incorrect. ${feedback.justification}`}*/}
            {/*            </p>*/}
            {/*        )}*/}
            {/*    </div>*/}
            {/*)}*/}



           